import * as ConfigTypes from './config/types';
import { type AppHistory, initialize as initializeHistory } from './history';
import * as intercomTracker from './intercomTracker/intercomTracker';
import * as assertInterface from './interfaces/assertInterface';
import * as crashReporterInterface from './interfaces/crashReporterInterface';
import * as httpClientInterface from './interfaces/httpClientInterface';
import {
  type LocalStorage,
  localStorageInrerfaceInit,
  localStorageInterface,
} from './interfaces/localStorageInterface';
import * as trackerInterface from './interfaces/trackerInterface';
import * as localPreferences from './local-preferences';
import { initialize as initializePlatform } from './platform';
import * as PlatformTypes from './platform/types';
import coreSettings from './settings';

export interface UtilsCoreOptions {
  history?: AppHistory;
  platform?: PlatformTypes.Platform;
  localStorage: LocalStorage;
}

export const initializeUtilsCore = (options: UtilsCoreOptions): void => {
  const { history, platform, localStorage } = options;
  localStorageInrerfaceInit(localStorage);
  initializePlatform(platform);
  initializeHistory(history);
};

export * from './config';
export { default as config } from './config';
export type { BuildConfig, ClientConfig, CommonConfig, Config, EnvironmentConfig, HostConfig } from './config/types';
export type { AppHistory } from './history';
export { default as history } from './history';
export * from './httpErrors';
export type { IntercomEventDispatcher, IntercomEventMetadata } from './intercomTracker/intercomTracker';
export type { AssertFn, AssertInterface } from './interfaces/assertInterface';
export type {
  BreadcrumbMetadata,
  BreadcrumbType,
  CrashReportDetails,
  CrashReporter,
  CrashReportOverrides,
} from './interfaces/crashReporterInterface';
export type { HttpInterface } from './interfaces/httpClientInterface';
export type { LocalStorage } from './interfaces/localStorageInterface';
export type { TrackerInterface, TrackingProperties } from './interfaces/trackerInterface';
export type { Logger, LogLevel } from './logger';
export { configurator as loggerConfigurator, getLogger } from './logger';
export { default as platform } from './platform';
export type { Platform } from './platform/types';
export { default as tracker } from './tracker';
export { getReportTrackingProps } from './tracker/getReportTrackingProps';
export type { SeriesTabName } from './tracker/seriesTabTracking';
export { SERIES_SUBTAB_NAMES, trackSeriesSubtabClick, trackSeriesTabClick } from './tracker/seriesTabTracking';
export {
  assertInterface,
  ConfigTypes,
  coreSettings,
  crashReporterInterface,
  httpClientInterface,
  intercomTracker,
  localPreferences,
  localStorageInterface,
  PlatformTypes,
  trackerInterface,
};
